// Pre-computed block ranges where mints are known to exist.
// Grouped by proximity (blocks within 3000 of each other).
// Used to optimize initial load by targeting known ranges instead of scanning all blocks.

export const KNOWN_MINT_BLOCK_RANGES = [
  [13802012, 13802012],
  [13847301, 13857777],
  [13863508, 13865000],
  [13870456, 13870456],
  [13877775, 13877775],
  [13914732, 13916529],
  [14009152, 14014273],
  [14058223, 14059110],
  [14076224, 14076224],
  [14113424, 14113624],
  [14131370, 14131370],
  [14144208, 14144427],
  [14147436, 14149383],
  [14225262, 14228012],
  [14234387, 14234402],
  [14420795, 14420795],
  [14608654, 14608654],
  [14801863, 14801863],
  [15004618, 15005074],
  [15063277, 15063748],
  [15068950, 15068950],
  [15075007, 15078800],
  [15091457, 15091473],
  [15108632, 15108632],
  [15113220, 15113220],
  [15154232, 15154232],
  [15160845, 15160845],
  [15174369, 15177392],
  [15187945, 15188351],
  [15197217, 15197217],
  [15246810, 15249712],
  [15264898, 15267037],
  [15283204, 15283204],
  [16177770, 16180812],
  [16386824, 16386903],
  [16833410, 16833410],
  [18017382, 18017382],
  [18024567, 18024567],
  [18052683, 18052683],
  [18059938, 18059938],
  [18074215, 18074215],
  [18081839, 18081839],
  [18095474, 18095474],
  [18103133, 18103133],
  [18110288, 18110288],
  [18131990, 18131990],
  [18153306, 18153306],
  [18173966, 18173966]
];

// Last known mint block
export const LAST_KNOWN_MINT_BLOCK = 18173966;

// Incremental scan starts here — skips the confirmed-dead zone after the last
// known mint. Set this to a recent block when no mints have occurred in between.
export const INCREMENTAL_SCAN_FROM_BLOCK = 21500000;

// Default start block for mainnet contract deployment
export const DEFAULT_FROM_BLOCK = 13789857;

// Rinkeby start block
export const RINKEBY_FROM_BLOCK = 9801044;

// Sepolia start block (set after deployment)
export const SEPOLIA_FROM_BLOCK = 0;
